var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":"/rules"}},[_c('i',{staticClass:"material-icons"},[_vm._v("build")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/create_rule"}},[_c('i',{staticClass:"material-icons"},[_vm._v("code")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }